import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { QuoteList } from "@/features/office/quotes";
import { quoteListSearchSchema } from "@/features/office/quotes/list/_configs/quote-list-search-schema";
import { useQuoteFeatureGate } from "@/features/shared/quote-feature-gate";

export const routeId = "/office/quotes";

export const Route = createFileRoute("/office/quotes")({
  validateSearch: quoteListSearchSchema,
  component: OfficeQuotesPage,
});

/**
 * The whole quote surface is behind `rollout_quote_feature` (R-1.5, R-15.1),
 * the sidebar entry included — so a user who reaches this URL without the gate
 * is sent back to their orders rather than shown an empty page. The redirect
 * replaces the history entry so Back does not bounce them straight back in.
 * Nothing renders while Statsig is still initialising: a cold cache must not
 * flash the list on and then redirect it away.
 */
function OfficeQuotesPage() {
  const { enabled, isLoading } = useQuoteFeatureGate();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !enabled) {
      navigate({ to: "/office/orders/active", replace: true });
    }
  }, [isLoading, enabled, navigate]);

  if (isLoading || !enabled) return null;

  return <QuoteList />;
}
